import React from "react";
import './Footer.css';


export default function Footer() {
    const s = {
        footer: {
            background: "#0f1724",
            color: "#e6eef8",
            padding: "28px 20px 16px",
            fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
            width: '100vw',
            marginLeft: 'calc(50% - 50vw)',
        },
        top: {
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 24,
            flexWrap: "wrap",
            maxWidth: 1100,
            margin: "0 auto",
        },
        col: {
            flex: "1 1 220px",
            minWidth: 200,
        },
        logoCol: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
        },
        logo: {
            maxWidth: 160,
            height: "auto",
            display: "block",
        },
        heading: {
            margin: "0 0 10px 0",
            fontSize: 16,
            color: "#ffffff",
        },
        navList: {
            listStyle: "none",
            padding: 0,
            margin: 0,
        },
        navItem: {
            marginBottom: 8,
        },
        link: {
            color: "#cfe7ff",
            textDecoration: "none",
            fontSize: 15,
        },
        contactText: {
            margin: "6px 0",
            fontSize: 14,
            color: "#cbd7e6",
        },
        bottom: {
            textAlign: "center",
            marginTop: 22,
            borderTop: "1px solid rgba(255,255,255,0.04)",
            paddingTop: 14,
            fontSize: 13,
            color: "#9fb7d6",
        },
    };

    return (
        <footer style={s.footer}>
            <div style={s.top}>
                <div style={s.col}>
                    <h4 style={s.heading}>Contact</h4>
                    <div style={s.contactText}>ISPARTA MERKEZ, Sanayi, 3326. SK NO:16 32200, 32200 merkez/Isparta <br /> Sanayi Garanti Bankası ara sokağı</div>
                    <div style={s.contactText}>Phone: +90 501 334 10 32</div>
                    <div style={s.contactText}>Email: info@ispartagezenadam.com</div>
                </div>

                {/* Center column - Navigation */}
                <div style={s.col}>
                    <h4 style={s.heading}>İletişim</h4>
                    <ul style={s.navList}>
                        <li style={s.navItem}>
                            <a href="/" style={s.link}>Anasayfa</a>
                        </li>
                        <li style={s.navItem}>
                            <a href="/about" style={s.link}>About</a>
                        </li>
                        <li style={s.navItem}>
                            <a href="/tours" style={s.link}>Hizmetlerimiz</a>
                        </li>
                        <li style={s.navItem}>
                            <a href="/contact" style={s.link}>İletişim</a>
                        </li>
                    </ul>
                </div>
                <div className="footer-logo-col" style={{ ...s.col, ...s.logoCol }}>
                    <img src='/Assets/logo.png' alt="Isparta Gezen Adam logo" style={s.logo} />
                </div>
            </div>

            <div style={s.bottom}>2026 Isparta Gezen Adam All rights reserved.</div>
        </footer>
    );
}